/*
  Ladezeichen fuer die UGC-Videos in der Vergroesserung (07.09.2026).

  WARUM: modal-swiper.js baut die Videoelemente erst beim Oeffnen und setzt
  dann erst die Quelle (<video src="..."> in _buildMarkup). Das Video laedt
  also von Null. Bis genug Daten da sind, steht das erste Bild still - fuer
  die Kundin sieht das aus wie ein kaputtes Video, nicht wie Laden.

  WIE: Medien-Ereignisse (loadstart, waiting, canplay ...) STEIGEN NICHT AUF,
  ein normaler Listener am document sieht sie also nie. Sie lassen sich aber in
  der ERFASSUNGSPHASE abfangen - daher das dritte Argument true. Damit braucht
  es keinen Eingriff in modal-swiper.js und keinen Beobachter, der auf das
  Erscheinen der Vergroesserung wartet.

  Die Klasse haengt am .swiper-slide, nicht am Video: Ein <video> kann kein
  ::after tragen, das Ladezeichen braucht aber ein eigenes Element. Der Slide
  steht bereits auf position:relative, der Kreis sitzt darin mittig.

  Nicht sichtbare Slides bekommen die Klasse ebenfalls - das ist gewollt und
  unsichtbar. Wischt man dorthin, dreht es sich bereits, statt erst zu starten.
*/
(function () {
  var KLASSE = 'is-video-laedt';

  function betrifftUns(e) {
    var v = e.target;
    return v && v.classList && v.classList.contains('video-reels-modal__video');
  }
  function slide(e) {
    return e.target.closest ? e.target.closest('.swiper-slide') : null;
  }
  function zeigen(e) {
    if (!betrifftUns(e)) return;
    var s = slide(e);
    if (s) s.classList.add(KLASSE);
  }
  function verbergen(e) {
    if (!betrifftUns(e)) return;
    var s = slide(e);
    if (s) s.classList.remove(KLASSE);
  }

  ['loadstart', 'waiting', 'stalled', 'seeking'].forEach(function (n) {
    document.addEventListener(n, zeigen, true);
  });
  // canplay UND playing: canplay kommt frueher, playing ist der sichere
  // Abschluss. error/abort/emptied sind Notausgaenge, damit sich der Kreis
  // nicht endlos weiterdreht, wenn ein Video gar nicht laedt.
  ['canplay', 'playing', 'seeked', 'pause', 'error', 'abort', 'emptied'].forEach(function (n) {
    document.addEventListener(n, verbergen, true);
  });
})();
